import * as React from "react";
import * as actions from "../../store/cases/actions";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import { Chat, Message } from "../../api/classes";
import {
  List,
  ListItem,
  Avatar,
  ListItemText,
  ListItemSecondaryAction,
  Badge,
  Chip,
  Typography,
  Divider,
  AppBar,
  Toolbar,
  CircularProgress,
  IconButton,
  TextField
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import * as moment from "moment";
import RefreshIcon from "@material-ui/icons/Refresh";
import SearchIcon from "@material-ui/icons/Search";

import "./scrollbar.css";
import { DubitoSvc } from "src/api";
import { getChatUsers } from "src/auth/auth";
import { GetMessagesRequest } from "src/api/DubitoAPI";
import EmptyState from "src/components/emptyState";

interface Props {
  chats: Chat[];
  onSelectChat: (chat: Chat) => void;
  onSelectChatID: (id: string) => void;
  fetchChatsBefore: (id) => void;
  fetchChatsAfter: (messages) => void;
  fetchChats: (cb?) => void;

  messages: Message[];
}
interface State {
  loading: boolean;
  refreshing: boolean;
  lastRefreshTime: moment.Moment;
  query: string;
  searchOpen: boolean;
}
class Chats extends React.Component<Props, State> {
  state = {
    loading: false,
    refreshing: false,
    lastRefreshTime: undefined,
    query: "",
    searchOpen: false
  };
  componentWillReceiveProps(next: Props) {
    if (this.props.chats.length < next.chats.length) {
      this.setState({ loading: false });
    }
  }
  componentDidMount() {
    // if (this.props.messages && this.props.messages.length > 0) {
    this.refresh(true);
    // }
  }
  renderSource(source: string) {
    let img = "";
    let color = "black";
    if (source === "twitter:message") {
      img = "/assets/img/inbox.png";
      color = "#1DA1F2";
    } else if (source === "twitter:mention") {
      img = "/assets/img/tw-icon.png";
      color = "#1DA1F2";
    } else if (source === "facebook:message") {
      img = "/assets/img/fb-icon.png";
      color = "#3B5998";
    }
    return (
      <Avatar
        style={{
          position: "absolute",
          width: 20,
          height: 20,
          bottom: 8,
          left: 16,
          backgroundColor: color
        }}
      >
        <img
          style={{
            width: 12,
            height: 12
          }}
          src={img}
        />
      </Avatar>
    );
  }
  refresh = (hard?) => {
    this.setState({ refreshing: true });
    const req = {} as GetMessagesRequest;
    if (!hard) {
      req.newestMessageId = this.props.messages[0].id;
      DubitoSvc.getMessages(req).then(res => {
        this.setState({ refreshing: false, lastRefreshTime: moment() });
        if (!hard) {
          this.props.fetchChatsAfter(res.messages);
        }
      });
    } else {
      this.props.fetchChats(() => {
        this.setState({ refreshing: false, lastRefreshTime: moment() });
      });
    }
  };
  renderSearchResult() {
    if (this.state.query.length === 0) {
      return null;
    }
    return getChatUsers()
      .filter(v => {
        if (this.state.query.length === 0) {
          return true;
        } else {
          if (
            v.account_name &&
            v.account_name.toLocaleLowerCase().indexOf(this.state.query) > -1
          ) {
            return true;
          }
        }
        return false;
      })
      .slice(0, 10)
      .map(chat => {
        return (
          <div key={chat.sender_id + chat.account_picture}>
            <ListItem
              button
              onClick={() => {
                this.props.onSelectChatID(chat.sender_id);
              }}
            >
              <div>
                <Avatar
                  src={chat.account_picture}
                  onError={(e: any) => {
                    e.target.onerror = null;
                    e.target.src = "/assets/img/avatar.png";
                  }}
                />
              </div>
              <ListItemText primary={chat.account_name} />
            </ListItem>
            <Divider />
          </div>
        );
      });
  }
  render() {
    if (!this.props.chats) {
      return <div>Loading</div>;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          width: 375
        }}
      >
        <AppBar position="static" color="default">
          <Toolbar>
            <ListItemText
              primary={"Inbox"}
              secondary={
                this.state.refreshing
                  ? "Updating..."
                  : this.state.lastRefreshTime &&
                    "Last update " + this.state.lastRefreshTime.format("HH:mm")
              }
            />
            {this.state.refreshing ? (
              <CircularProgress />
            ) : (
              <>
                <IconButton
                  onClick={() => {
                    this.refresh(true);
                  }}
                >
                  <RefreshIcon />
                </IconButton>
              </>
            )}
            <IconButton
              onClick={() =>
                this.setState({ searchOpen: !this.state.searchOpen })
              }
            >
              <SearchIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div
          style={{
            overflowY: "scroll",
            overflowX: "clip",
            scrollBehavior: "smooth",
            flex: 1
          }}
          onScroll={event => {
            if (!this.state.loading && this.state.query.length === 0) {
              const container = event.target as any;
              var scrollY = container.scrollHeight - container.scrollTop;
              var height = container.offsetHeight;
              var offset = height - scrollY;
              if (offset > -500) {
                //console.log("load!");
                this.setState({ loading: true }, () => {
                  const latestMessage = this.props.messages[
                    this.props.messages.length - 1
                  ];
                  this.props.fetchChatsBefore(latestMessage.id);
                });
              }
            }
          }}
        >
          {this.state.searchOpen && (
            <div style={{ padding: 8 }}>
              <TextField
                placeholder="Search"
                autoFocus
                onChange={e =>
                  this.setState({ query: e.target.value.toLocaleLowerCase() })
                }
                style={{ width: "100%" }}
                fullWidth
              />
            </div>
          )}
          <List
            style={{
              maxWidth: 375,
              marginRight: 8,
              marginLeft: 8,
              paddingLeft: 0,
              paddingRight: 0
            }}
          >
            {this.props.chats.length === 0 && <EmptyState />}
            {this.props.chats
              .filter(v => {
                if (this.state.query.length === 0) {
                  return true;
                } else {
                  if (
                    v.account_name &&
                    v.account_name
                      .toLocaleLowerCase()
                      .indexOf(this.state.query) > -1
                  ) {
                    return true;
                  }
                }
                return false;
              })
              .map(chat => {
                return (
                  <div key={chat.id}>
                    <ListItem
                      button
                      onClick={() => this.props.onSelectChat(chat)}
                    >
                      <div>
                        <Avatar
                          src={chat.account_picture}
                          onError={(e: any) => {
                            e.target.onerror = null;
                            e.target.src = "/assets/img/avatar.png";
                          }}
                        />
                        {this.renderSource(chat.source)}
                      </div>
                      <ListItemText
                        primary={chat.account_name}
                        secondary={
                          chat.recipient_id + "" !== "765187661996883968" &&
                          chat.recipient_id + "" !== "207787009653168" &&
                          chat.source !== "twitter:mention" ? (
                            <div>
                              <CheckIcon style={{ width: 16, height: 16 }} />{" "}
                              {chat.text}
                            </div>
                          ) : (
                            chat.text
                          )
                        }
                        secondaryTypographyProps={{
                          style: {
                            maxLines: 1,
                            whiteSpace: "nowrap",
                            overflow: "hidden"
                          }
                        }}
                      />
                      <ListItemSecondaryAction
                        style={{
                          display: "flex",
                          flexDirection: "column"
                        }}
                      >
                        <Typography
                          variant="caption"
                          style={{
                            alignSelf: "flex-start",
                            flex: 1,
                            marginTop: chat.unreads > 0 ? 0 : -16
                          }}
                        >
                          {moment(chat.created_at).calendar(undefined, {
                            sameDay: "HH:mm",
                            nextDay: "LL",
                            nextWeek: "LL",
                            lastDay: "[Yesterday] hh:mm",
                            lastWeek: "LL",
                            sameElse: "LL"
                          })}
                        </Typography>
                        {chat.unreads > 0 && (
                          <Chip
                            label={chat.unreads}
                            style={{
                              backgroundColor: "#19D164",
                              color: "white",
                              width: 20,
                              height: 20,
                              alignSelf: "flex-end",
                              marginTop: 8,
                              fontSize: 11
                            }}
                          />
                        )}
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                  </div>
                );
              })}
            {this.renderSearchResult()}
            {this.state.loading && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%"
                }}
              >
                <CircularProgress style={{ alignSelf: "center" }} />
              </div>
            )}
          </List>
        </div>
      </div>
    );
  }
}
function matchPropsToDispatch(state: GlobalState, own: any) {
  return {
    chats: state.cases.chats,
    messages: state.cases.messages
  };
}
export default connect(
  matchPropsToDispatch,
  dispatch => ({
    fetchChats: (cb?) => dispatch(actions.fetchChats(cb)),
    fetchChatsAfter: (id): any => dispatch(actions.fetchChatsAfter(id)),
    fetchChatsBefore: (id): any => dispatch(actions.fetchChatsBefore(id))
  })
)(Chats);



// WEBPACK FOOTER //
// ./src/pages/messages/chats.tsx